module.exports = __webpack_public_path__ + "img/tarde_3@2x.adc96c9f.jpg";